import React from 'react';
import { createCommand } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';
import { createI18nT } from '../i18n.js';

export const devCommand = (services: CommandServices, cliVersion: string) => {
  const t = createI18nT();

  return createCommand('dev')
    .description(t('site_dev_command_def.description'))
    .option('--tunnel', t('site_dev_command_def.option.tunnel'))
    .action(async (options, command) => {
      const { tunnel = false } = options;
      const { renderCommand } = await import('./render-command.js');
      const { DevCommand } = await import(
        '../components/DevCommand/DevCommand.js'
      );

      await renderCommand(
        command,
        services,
        cliVersion,
        <DevCommand useTunnel={tunnel} />
      );
    });
};
